function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".pay-rent-online_svg__cls-1{fill:none;stroke:#2d4658;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.3px}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "pay-rent-online_svg__Shape_1289",
  "data-name": "Shape 1289",
  className: "pay-rent-online_svg__cls-1",
  d: "M6 23.46l2.55-1A4.78 4.78 0 0 0 12 23.87h7.24l1.56-5.79"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "pay-rent-online_svg__Shape_1290",
  "data-name": "Shape 1290",
  className: "pay-rent-online_svg__cls-1",
  d: "M20.78 18.08h-6.1a1.45 1.45 0 1 0 0 2.89h3.86"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "pay-rent-online_svg__Shape_1291",
  "data-name": "Shape 1291",
  className: "pay-rent-online_svg__cls-1",
  d: "M19.77 21h-2.42a1.45 1.45 0 0 0 0 2.9h1.45"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.24 10a1.85 1.85 0 0 1 .18.8v.49c0 1.21-1.09 2.09-2.58 2.09h-1.46c-.32.89-1.12 2.64-2.5 3.2a2.12 2.12 0 0 0 1.66.82h7.9a2.37 2.37 0 0 1 1.1-1.59 4.35 4.35 0 0 1 4.35-4.32A4.3 4.3 0 0 1 30.11 13v-3zm-.39 5.68H15a.65.65 0 0 1 0-1.3h2.9a.65.65 0 1 1 0 1.3zm12.26-7.57V6.66A2.1 2.1 0 0 0 28 4.56H13.54a2.1 2.1 0 0 0-2.1 2.1v1.45z",
  fill: "#00c5ba"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "pay-rent-online_svg__cls-1",
  transform: "rotate(-7.74 3.652 19.552)",
  d: "M2.12 13.7h3.06v11.65H2.12z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "pay-rent-online_svg__Interface-Essential_Lock_Unlock_lock-1",
  "data-name": "Interface-Essential / Lock/Unlock / lock-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "pay-rent-online_svg__Group_125",
  "data-name": "Group 125"
}, /*#__PURE__*/React.createElement("g", {
  id: "pay-rent-online_svg__lock-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M27.72 19.43a.92.92 0 1 0-1.83 0 .88.88 0 0 0 .42.74v.91a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-.91a.9.9 0 0 0 .41-.74z",
  fill: "#2d4658"
}), /*#__PURE__*/React.createElement("path", {
  id: "pay-rent-online_svg__Rectangle-path_43",
  "data-name": "Rectangle-path 43",
  className: "pay-rent-online_svg__cls-1",
  d: "M23.29 17.57a.42.42 0 0 1 .42-.42h6.2a.42.42 0 0 1 .41.42v5a.41.41 0 0 1-.41.41h-6.2a.41.41 0 0 1-.42-.41z"
}), /*#__PURE__*/React.createElement("path", {
  id: "pay-rent-online_svg__Shape_765",
  "data-name": "Shape 765",
  className: "pay-rent-online_svg__cls-1",
  d: "M24.53 15.71a2.28 2.28 0 1 1 4.55 0v1.44h-4.55z"
}))));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "pay-rent-online_svg__Shape_1288",
  "data-name": "Shape 1288",
  className: "pay-rent-online_svg__cls-1",
  d: "M11 16.15c1.93 0 2.9-3.38 2.9-3.38h1.93c1 0 1.93-.48 1.93-1.44v-.49c0-1-1-1.44-1.93-1.44h-2.9a5.45 5.45 0 0 0-5.43 3.86l-2.63 1.27"
});

const SvgPayRentOnline = props => /*#__PURE__*/React.createElement(Svg, _extends({
  id: "pay-rent-online_svg__Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);

export default SvgPayRentOnline;